import { ErrorKey } from 'hooks/checkout/useExpressCheckoutError/type';
import {
  createErrorTranslationKey,
  ErrorTranslationKeys,
} from '../../constants/error-translation-keys';
import { HttpStatus } from '../../constants/http-status';

export default {
  'error:invalid_login': 'Wachtwoord of e-mail is helaas niet juist.',
  'error:erasure_pending':
    'Het account dat aan dit e-mailadres is gekoppeld en de bijbehorende gegevens staan gepland om verwijderd te worden',
  'error:email_in_use':
    'Er bestaat al een account met dit e-mailadres. Gebruik de login om je aan te melden bij je Pets Deli account.',
  'error:account_suspended':
    'Om toegang tot je klantaccount te krijgen, neem je contact op met onze klantenservice: {email}',

  // Password reset
  'error:Could not find customer': 'Klant kon niet gevonden worden',
  'error:Ungültige URL zum Zurücksetzen': 'De link is verlopen. Vraag een nieuwe aan!',

  'error:graphql:Too many requests. Please try again in a few seconds':
    'Te veel verzoeken. Probeer het iets later opnieuw',

  'error:unknown': 'Er is helaas een fout opgetreden. Probeer het later opnieuw.',
  'error:unknown_error': 'Er is helaas een fout opgetreden. Probeer het later opnieuw.',
  [`error:http-status:${HttpStatus.BAD_REQUEST}`]: 'Het verzoekbericht was verkeerd opgebouwd',
  [`error:http-status:${HttpStatus.UNAUTHORIZED}`]:
    'Het verzoek kan niet worden uitgevoerd zonder geldige authenticatie',
  [`error:http-status:${HttpStatus.FORBIDDEN}`]:
    'Het verzoek is niet uitgevoerd omdat de client niet gemachtigd is',
  [`error:http-status:${HttpStatus.NOT_FOUND}`]: 'De gevraagde bron is niet gevonden',
  [`error:http-status:${HttpStatus.INTERNAL_SERVER_ERROR}`]: 'Er is een serverfout opgetreden',
  [`error:http-status:${HttpStatus.BAD_GATEWAY}`]:
    'De server kon zijn functie als gateway of proxy niet vervullen',
  [`error:http-status:${HttpStatus.SERVICE_UNAVAILABLE}`]:
    'De server is tijdelijk niet beschikbaar',

  [`error:express-checkout:${ErrorKey.Undefined}`]:
    'De betaling kon niet worden voltooid. Gebruik een andere methode.',
  [`error:express-checkout:${ErrorKey.Unknown}`]:
    'De betaling kon niet worden voltooid. Gebruik een andere methode.',
  'error:account:bonus-program:insufficient': 'Punten zijn ontoereikend',
  'error:express-checkout:invalid-address':
    'Op dit adres is een bestelling via petsdeli.de niet mogelijk.',
  [`error:express-checkout:${ErrorKey.InstrumentDeclined}`]:
    'Je betaling is helaas mislukt. Controleer de kaartlimiet of het beschikbare bedrag op de kaart.',
  'error:page:page-title:page-not-found': 'Pagina niet gevonden',
  'error:page:page-title:error': 'Fout',
  'error:page:header': 'We kunnen de pagina die je zoekt niet vinden.',
  'error:page:suggestions:header': 'Hier zijn in plaats daarvan enkele handige links:',
  'error:page:suggestions:home': 'Home',
  'error:page:suggestions:foodaid': 'Voeradviseur',
  'error:page:suggestions:account': 'Account',
  'error:page:suggestions:cart': 'Winkelwagen',
  'error:page:generic-error-message': 'Er is helaas net een fout opgetreden!',
  'error:invoice-download-error-message': 'Je factuur is nog niet beschikbaar.',

  'error:products:product-not-available':
    'Het geselecteerde product is helaas niet meer beschikbaar.',
  'error:products:unrecoverable-shopify-checkout-error':
    'Sorry, er is iets misgegaan met je winkelwagen. We hebben je winkelwagen gereset.',
  [createErrorTranslationKey(
    ErrorTranslationKeys.UNIQUE_CONSTRAINT.PREFIX,
    ErrorTranslationKeys.UNIQUE_CONSTRAINT.TYPES.PET_NAME_EXISTS
  )]: 'Je hebt al een bestaand profiel met deze naam.',
};
